import _typeof from "@babel/runtime/helpers/typeof";
import { generateCorrelationId, correlationIdHeaderName } from './telemetry';
export default function sendBeacon(url, data) {
  var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'text/plain';
  var correlationId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : generateCorrelationId();
  // Format data
  if (data && _typeof(data) === 'object') {
    data = JSON.stringify(data);
  }

  // Send
  if (navigator.sendBeacon) {
    var blob = new Blob([data], {
      type: contentType
    }); // we can't send any header apart from "type" (content-type) using navigator.sendBeacon
    navigator.sendBeacon(url, blob);
  } else {
    var xhr = new XMLHttpRequest();
    xhr.open('post', url, false);
    xhr.setRequestHeader('Content-Type', contentType);
    xhr.setRequestHeader(correlationIdHeaderName, correlationId);
    xhr.send(data);
  }
}